// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/SF-Compact-Text-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/brutal-font/BrutalType-ExtraLight.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/brutal-font/BrutalType-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/brutal-font/BrutalType-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/brutal-font/BrutalType-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/fonts/brutal-font/BrutalType-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/fonts/brutal-font/BrutalType-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/fonts/brutal-font/BrutalType-Thin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./assets/fonts/brutal-font/BrutalType-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./assets/fonts/brutal-font/BrutalType-ExtraBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./assets/fonts/brutal-font/BrutalType-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./assets/fonts/brutal-font/BrutalType-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./assets/fonts/brutal-font/BrutalType-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./assets/fonts/brutal-font/BrutalType-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./assets/fonts/brutal-font/BrutalType-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("./assets/fonts/brutal-font/BrutalType.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("./assets/fonts/brutal-font/BrutalType.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("./assets/fonts/Karloff/Karloff-Neutral-Regular-Web.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@500;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "SF-Compact";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("ttf");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "BrutalType";
  src: local("BrutalType-ExtraLight"), local("BrutalType-ExtraLight"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: 200;
  font-style: normal;
}
@font-face {
  font-family: "BrutalType";
  src: local("BrutalType-Medium"), local("BrutalType-Medium"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "BrutalType";
  src: local("BrutalType-Bold"), local("BrutalType-Bold"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
  font-weight: bold;
  font-style: normal;
}
@font-face {
  font-family: "BrutalType";
  src: local("BrutalType-Thin"), local("BrutalType-Thin"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype");
  font-weight: 100;
  font-style: normal;
}
@font-face {
  font-family: "BrutalType";
  src: local("BrutalType-ExtraBold"), local("BrutalType-ExtraBold"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype");
  font-weight: 800;
  font-style: normal;
}
@font-face {
  font-family: "BrutalType";
  src: local("BrutalType-Black"), local("BrutalType-Black"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("truetype");
  font-weight: 900;
  font-style: normal;
}
@font-face {
  font-family: "BrutalType";
  src: local("BrutalType-Light"), local("BrutalType-Light"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype");
  font-weight: 300;
  font-style: normal;
}
@font-face {
  font-family: "BrutalType";
  src: local("BrutalType"), local("BrutalType"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Karloff";
  src: local("Karloff"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("woff2");
  font-weight: normal;
  font-style: normal;
}
:root {
  --headerHeight: 64px;
  --sidebarWidth: 266px;
}

body {
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: var(--color-main-bg);
  color: var(--color-main-text) !important;
  font-family: var(--font-family);
  font-size: var(--main-font-size);
  height: 100%;
  line-height: var(--main-font-height);
  overflow: hidden;
}

html, body, #root {
  height: 100%;
}

* {
  margin: 0;
  padding: 0;
  text-decoration: none;
  list-style-type: none;
  box-sizing: border-box;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
}

body {
  background: radial-gradient(101.77% 75.82% at 50% 43%, #292201 0, #000 55.45%);
}

#root {
  display: flex;
  align-items: center;
  justify-content: center;
}
@media screen and (((min-width: 576px) and (min-height: 830px)) or (orientation: landscape)) {
  #root {
    padding: 70px 0 10px;
    min-height: 100%;
  }
}
@media screen and (orientation: landscape) and (max-height: 600px) {
  #root .main-theme--dark .container {
    margin-bottom: 70px;
  }
  #root .main-theme--dark footer {
    padding-bottom: 16px;
  }
}

main {
  height: 100%;
  width: 100%;
  background-color: #fff;
  overflow: hidden;
}
@media screen and (orientation: landscape) {
  main .form-actions {
    padding-bottom: 20px;
  }
}
main .section {
  height: 100%;
  display: flex;
  flex-direction: column;
}
@media screen and (min-width: 1024px) {
  main {
    position: relative;
  }
}

.outlined-btn {
  border-radius: 16px;
  background: rgba(35, 58, 64, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.pointer {
  cursor: pointer;
}

.text-center {
  text-align: center;
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.thumbnail {
  display: flex;
  align-items: center;
  justify-content: center;
}
.thumbnail img {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  overflow: hidden;
  object-fit: cover;
}

.bold {
  font-weight: 700;
}

@keyframes fadeInAnim {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
:root {
  --color-main-bg: #000000;
  --color-main-text: #ffffff;
  --color-main-secondary-text: #9d9d9d;
  --color-main-border:#d3d3d3;
  --color-main-secondary-bg:#232323;
  --color-action-active: #FFDF00;
  --color-action-hover: #E4D200;
  --color-action-tapped: #ffe845;
  --color-action-link-hovered:#ffea57;
  --color-action-disabled-small: #c4c4c4;
  --color-action-disabled-big: #fff9cc;
  --color-action-select-borders: #fff9cc;
  --color-action-small-round-buttons: #FFF6EB;
  --color-encore-primary-error: #ff3838;
  --color-encore-secondary-error: #8f2323;
  --filter-color-action-svg: brightness(0) saturate(100%) invert(91%) sepia(17%) saturate(3852%) hue-rotate(357deg) brightness(100%) contrast(105%);
  --filter-color-error-primary-svg: brightness(0) saturate(100%) invert(30%) sepia(87%) saturate(1709%) hue-rotate(338deg) brightness(98%) contrast(106%);
  --filter-color-svg: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7437%) hue-rotate(32deg) brightness(116%) contrast(106%);
  --header-height: 48px;
  --button-height: 48px;
  --input-height: 52px;
  --karloff: "Karloff", serif;
  --brutal: "BrutalType", sans-serif;
  --roboto: "Roboto", sans-serif;
  --roboto-mono: "Roboto Mono", monospace;
  --font-family: var(--brutal);
  --main-font-size: 17px;
  --main-font-height: 24px;
  --description-font-height: 21px;
  --secondary-font-size: 14px;
  --secondary-font-height: 17px;
  --header-font-size: 28px;
  --header-font-height: 32px;
  --max-content-width: 600px;
  --max-modal-width: 660px;
  --max-button-width: 352px;
  --wrapper-width: 432px;
  --metamask-wrapper-width: 448px;
  --border-radius-wrapper: 24px;
  --metamask-border-radius: 8px;
  --space-content-x: 24px;
  --space-center-modal-x: 16px;
  --space-content-wrapper: 66px;
  --z-index-header-modal: 100;
  --z-index-cookies: 101;
  --z-index-header: 102;
  --z-index-desktop-modal-bg: 103;
  --z-index-desktop-select: 104;
  --z-index-tooltip: 105;
  --z-index-modal: 106;
  --z-index-converter-modal: 107;
  --z-index-currency-select-modal: 108;
  --z-index-country-modal: 109;
  --z-index-country-select-modal: 110;
  --z-index-loader: 111;
  --z-index-notification: 112;
  --z-index-global-error: 113;
  --z-index-landing: 114;
  --z-index-global-modal: 115;
  --z-index-intercom: 116;
  --input-error-animation: I8IGq 6s forwards;
  --burger-line-open-animation-name: _F1_a;
  --burger-line-close-animation-name: FjdJQ;
}

@media (max-height: 672px), (max-width: 486px) {
  :root {
    --space-content-wrapper: 0;
    --space-content-x: 16px;
  }
}
.main-theme .header {
  background-color: transparent;
}
.main-theme .header .navbar-toggler {
  margin-right: -4px;
}
.main-theme .has-error {
  position: relative;
}
.main-theme .has-error .form-control {
  border-color: var(--color-encore-primary-error) !important;
}
.main-theme .has-error .error-message {
  animation: var(--input-error-animation);
  font-size: var(--secondary-font-size);
  line-height: var(--secondary-font-height);
  padding: 4px 0 8px;
  color: var(--color-encore-primary-error);
}
.main-theme .has-error .thumbnail.symbol-bg {
  border-color: var(--color-encore-primary-error);
}
.main-theme .has-error .error-message.pos {
  color: var(--color-encore-primary-error);
  font-size: var(--secondary-font-size);
  grid-column: 1/-1;
  height: 30px;
  line-height: var(--secondary-font-height);
  margin: -21px 0 10px;
  padding: 8px 0 3px;
  transition-duration: 0.2s;
  transition-property: height, padding;
  will-change: height, padding;
}
.main-theme .complete-form {
  height: 100%;
}
.main-theme .complete-form .email-agree {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 16px;
}
.main-theme .complete-form .email-agree .text {
  font-size: 14px;
  margin: 0 4px;
}
.main-theme .complete-form .email-agree .optional-label {
  background-color: var(--color-main-secondary-bg);
  border-radius: 3px;
  color: var(--color-main-secondary-text);
  font-size: 12px;
  font-weight: 500;
  line-height: 13px;
  padding: 2px 5px;
}
.main-theme .complete-form .email-agree .email-agree-input {
  visibility: hidden;
  position: absolute;
}
.main-theme .complete-form .email-agree .email-agree-input:checked + .border {
  background: var(--color-action-active);
  border-color: var(--color-action-active);
}
.main-theme .complete-form .email-agree .email-agree-input:checked + .border svg {
  display: block;
  min-width: 16px;
}
.main-theme .complete-form .email-agree .border {
  -webkit-box-align: center;
  -moz-box-align: center;
  -webkit-box-pack: center;
  -moz-box-pack: center;
  align-items: center;
  background: inherit;
  border: 1px solid var(--color-main-border);
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  height: 16px;
  justify-content: center;
  outline: none;
  padding: 0 2px;
  transition-duration: 0.2s;
  transition-property: background, border-color;
  width: 16px;
}
.main-theme .complete-form .email-agree .border svg {
  display: none;
}
.main-theme .complete-form .regular-label {
  display: block;
  font-size: var(--secondary-font-size);
  font-weight: 500;
  line-height: var(--secondary-font-height);
  margin: 2px 0 8px;
}
.main-theme .complete-form .form-control {
  border: 1px solid var(--color-main-border);
  border-radius: 8px;
  padding: 13px 16px;
  color: #fff;
}
.main-theme .complete-form .form-control:focus {
  outline: none;
}
.main-theme .complete-form .headings .complete-title {
  display: block;
  font-family: var(--karloff);
  font-size: var(--header-font-size);
  font-weight: 400;
  line-height: var(--header-font-height);
  margin-block: 6px 10px;
}
.main-theme .complete-form .headings .complete-title + .description {
  font-size: var(--main-font-size);
  line-height: var(--description-font-height);
  margin: 0 0 5px;
}
.main-theme .complete-form .terms-text {
  color: var(--color-main-secondary-text);
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  margin-top: 16px;
}
.main-theme .complete-form .terms-text a {
  color: var(--color-action-active);
  cursor: pointer;
  text-decoration: none;
}
.main-theme .container {
  height: calc(100% - var(--headerHeight));
}
.main-theme .sidebar__list {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 80%;
  justify-content: center;
  padding-top: 60px;
}
.main-theme .sidebar__list .heading-2 {
  font-weight: 400;
}
.main-theme .logo-wrapper {
  display: flex;
  align-items: center;
}
.main-theme--dark {
  background: var(--color-main-bg);
  color: var(--color-main-text);
  display: flex;
  flex-direction: column;
  font-family: var(--font-family);
  font-size: var(--main-font-size);
  height: 100%;
  line-height: var(--main-font-height);
  margin: auto;
  overflow: hidden;
  position: relative;
  border-radius: 0;
  max-height: 100%;
  width: 100%;
}
.main-theme--dark .btn--icon:not(:disabled):not(:focus):hover {
  opacity: 1;
}
.main-theme--dark .widget-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.main-theme--dark .widget-header .back-action {
  cursor: pointer;
}
.main-theme--dark .container {
  padding: 4px var(--space-content-x) 22px;
}
.main-theme--dark .widget-container {
  height: 100%;
}
.main-theme--dark .widget-container iframe {
  border-radius: 24px;
}
.main-theme--dark .transparent {
  background: transparent;
  vertical-align: middle;
}
.main-theme--dark .flexed-wrapper {
  display: flex;
  align-items: center;
  font-size: 25px;
  line-height: 27px;
  margin-block: 7px;
  width: 100%;
}
.main-theme--dark .flexed-wrapper.page-title {
  margin-block: 9px 7px;
}
.main-theme--dark .buy-sell-btn {
  font-size: 25px;
  line-height: 27px;
  margin-block: 9px 7px;
  appearance: none;
  background: none;
  border: none;
  cursor: pointer;
  outline: none;
  width: auto;
  border-bottom: 1px solid rgba(0, 0, 0, 0);
  color: var(--color-main-secondary-text);
  margin: 0 17px 0 0;
  padding: 0 0 4px;
  font-family: var(--karloff);
  font-weight: 400;
}
.main-theme--dark .buy-sell-btn.selected {
  border-bottom: 1px solid var(--color-main-border);
  color: var(--color-main-text);
  cursor: default;
}
.main-theme--dark .regular-label {
  display: block;
  font-size: var(--secondary-font-size);
  font-weight: 500;
  line-height: var(--secondary-font-height);
  margin-top: 2px;
}
.main-theme--dark .form-input.form-control .form-control {
  appearance: none;
  background: inherit;
  border: none;
  color: inherit;
  font-family: inherit;
  font-size: var(--main-font-size);
  height: var(--input-height);
  line-height: var(--main-font-height);
  margin: 0;
  outline: none;
  padding: 13px 0 11px;
  text-align: inherit;
  transition-duration: 0.2s;
  transition-property: background-color, color, border-color;
  width: 100%;
  border: 1px solid var(--color-main-border);
  border-radius: 8px 0 0 8px;
  padding: 13px 16px;
  font-weight: 400;
  border-right: 0;
}
.main-theme--dark .form-input {
  flex: 1 1;
}
.main-theme--dark .main-form {
  margin: 21px 0 0;
}
.main-theme--dark .main-form.second-form {
  margin: 5px 0 0 0;
  padding-bottom: 42px;
}
.main-theme--dark .main-form.second-form .accordion {
  margin: auto 0 20px;
}
.main-theme--dark .main-form.second-form .wallet-input-container {
  -webkit-box-align: center;
  display: flex;
  align-items: center;
}
.main-theme--dark .main-form.second-form .wallet-input-container .wallet-placeholder {
  align-items: center;
  color: var(--color-main-secondary-text);
  display: grid;
  font-size: 15px;
  grid-template-columns: 1fr auto;
  left: 16px;
  line-height: 24px;
  pointer-events: none;
  position: absolute;
}
.main-theme--dark .thumbnail.symbol-bg {
  background-color: transparent;
  border: 1px solid var(--color-main-border);
  border-left: none;
  border-radius: 0 8px 8px 0;
  height: var(--input-height);
  padding-right: 10px;
  transition: border-color 0.2s;
  margin: 0;
  font-family: var(--brutal);
}
.main-theme--dark .thumbnail.symbol-bg .sign {
  align-items: center;
  border: 1px solid var(--color-action-select-borders);
  border-radius: 3px;
  font-size: 17px;
  font-weight: 400;
  min-width: 47px;
  color: var(--color-action-active);
  display: flex;
  height: 24px;
  line-height: var(--secondary-font-height);
  padding: 0 6px;
  position: relative;
  transform: translateY(1px);
  transition: border-color 0.2s, color 0.2s;
}
.main-theme--dark .thumbnail.symbol-bg .sign span {
  margin: 0 auto;
}
.main-theme--dark .thumbnail.symbol-bg .crypto-icon {
  background: var(--color-main-bg);
  border-radius: 50%;
  height: auto;
  position: absolute;
  right: -9px;
  top: -10px;
  width: 15px;
  z-index: 1;
}
.main-theme--dark .thumbnail.symbol-bg .crypto-icon img {
  filter: var(--filter-color-action-svg);
  width: 100%;
  height: 100%;
  border-radius: 0;
}
.main-theme--dark .btn {
  font-family: var(--brutal);
}
.main-theme--dark .btn .regular-text {
  font-size: 17px;
  font-weight: 700;
}
.main-theme--dark .submit-btn.btn--primary {
  background: var(--color-action-active);
  border-radius: 8px;
  color: var(--color-main-bg);
  display: inline-block;
  font-weight: 700;
  height: 100%;
  max-height: var(--button-height);
  min-height: var(--button-height);
  text-align: center;
  transition: background-color 0.2s;
  width: 100%;
}
.main-theme--dark .submit-btn.btn--primary:hover:not(:disabled):not(:active) {
  background-color: var(--color-action-hover);
}
.main-theme--dark .submit-btn.btn--primary:disabled {
  background: var(--color-action-disabled-big);
  cursor: default;
}
.main-theme--dark .modal__content {
  background: var(--color-main-bg);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.03);
  height: 100%;
  border-radius: 0;
}
.main-theme--dark .modal__content .btn {
  position: absolute;
  z-index: 99999;
  left: auto;
  padding: 18px var(--space-content-x);
  right: 6px;
  top: 0;
}
.main-theme--dark .modal__content__body {
  padding: 16px var(--space-content-x);
  max-height: 100%;
}
.main-theme--dark .modal .search-wrapper {
  z-index: 9999;
  border-bottom: 1px solid var(--color-main-border);
  height: 48px;
  background: var(--color-main-bg);
  margin-bottom: 0;
  position: unset;
}
.main-theme--dark .modal .search-wrapper .form-input--search {
  padding: 0 0 0 28px;
}
.main-theme--dark .modal .search-wrapper .form-input--search::before {
  z-index: -1;
  content: "";
  position: absolute;
  top: 0;
  left: -14px;
  width: 108.5%;
  height: 100%;
  background: #000000;
  opacity: 1;
  transition: opacity 0.3s;
}
.main-theme--dark .modal .search-wrapper .form-input--search:hover::before {
  opacity: 1;
}
.main-theme--dark .modal .search-wrapper .form-control {
  appearance: none;
  background: inherit;
  border: none;
  color: inherit;
  font-family: inherit;
  font-size: var(--main-font-size);
  height: var(--input-height);
  line-height: var(--main-font-height);
  margin: 0;
  outline: none;
  padding: 13px 0 11px;
}
.main-theme--dark .modal .modal-heading {
  background: var(--color-main-bg);
  position: sticky;
  margin-top: -24px;
  top: -24px;
  z-index: 9999;
  padding-bottom: 14px;
  padding-top: 50px;
}
.main-theme--dark .modal .modal-heading::before {
  z-index: -1;
  content: "";
  position: absolute;
  top: 0;
  left: -14px;
  width: 108.5%;
  height: 100%;
  background: #000000;
  opacity: 1;
  transition: opacity 0.3s;
}
.main-theme--dark .modal .modal-heading:hover::before {
  opacity: 1;
}
.main-theme--dark .modal .select-list__item {
  grid-gap: 8px;
  align-items: center;
  border-bottom: 1px solid var(--color-main-border);
  display: grid;
  grid-template-columns: auto 1fr auto;
  padding: 8px 0;
  position: relative;
  border-radius: 0;
  margin-bottom: 0;
}
.main-theme--dark .modal .select-list__item .content {
  color: #fff;
}
.main-theme--dark .modal .select-list__item .content .regular-text {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: currentColor;
  font-size: 17px;
}
.main-theme--dark .modal .descr {
  line-height: 21px;
  margin: 5px 0 0;
}
.main-theme--dark footer {
  margin-block: auto -1px;
  padding-top: 10px;
}
.main-theme--dark footer .by {
  font-size: 14px;
  line-height: 17px;
}
.main-theme--dark footer a {
  color: #fff;
}
.main-theme--dark footer .powered-by {
  height: 12px;
  max-width: 82px;
  transform: translateY(4px);
  width: 100%;
}
.main-theme--dark .form-input .search-icon,
.main-theme--dark .form-input .voice-icon {
  top: 44%;
}
.main-theme--dark .modal.country-modal .thumbnail {
  background: var(--color-main-border);
  border: 1px solid var(--color-main-border);
  border-radius: 50%;
  height: 31px;
  width: 31px;
  overflow: hidden;
}
.main-theme--dark .modal.country-modal .thumbnail img {
  width: 100%;
  height: 100%;
}
.main-theme--dark .modal.currency-modal .search-wrapper {
  margin: 0;
  position: sticky;
  top: -60px;
  z-index: 9999;
  height: auto;
  margin-top: 42px;
}
.main-theme--dark .modal.currency-modal .search-wrapper .form-input--search {
  z-index: 9999;
  height: 44px;
}
.main-theme--dark .modal.currency-modal .search-wrapper .form-input--search::before {
  z-index: -1;
  content: "";
  position: absolute;
  top: 0;
  left: -14px;
  width: 108.5%;
  height: 100%;
  background: #000000;
  opacity: 1;
  transition: opacity 0.3s;
}
.main-theme--dark .modal.currency-modal .search-wrapper .form-input--search:hover::before {
  opacity: 1;
}
.main-theme--dark .modal.currency-modal .thumbnail img {
  background: #232323;
  border: 1px solid var(--color-main-text);
  border-radius: 50%;
  color: var(--color-main-bg);
  height: 42px;
  max-height: 42px;
  max-width: 42px;
  min-height: 42px;
  min-width: 42px;
  overflow: hidden;
  width: 42px;
}
.main-theme--dark .modal.currency-modal .form-input .search-icon, .main-theme--dark .modal.currency-modal .form-input .voice-icon {
  top: 47%;
}
.main-theme--dark .modal.currency-modal .modal__content .btn {
  z-index: 99999;
  right: -2px;
  top: 4px;
}
.main-theme--dark .modal.currency-modal .select-list__item {
  grid-gap: 12px;
}
.main-theme--dark .modal.currency-modal .list {
  padding: 19px 0 0;
  scroll-margin: var(--scroll-margin);
}
.main-theme--dark .modal.currency-modal .list:last-of-type {
  padding-bottom: 60px;
}
.main-theme--dark .modal.currency-modal .fiat {
  font-family: var(--brutal);
  font-size: var(--secondary-font-size);
  font-weight: 500;
  line-height: var(--secondary-font-height);
  margin: 0 0 13px;
}
.main-theme--dark .modal.currency-modal .select-list .type {
  border: 1px solid var(--color-main-border);
  border-radius: 3px;
  margin: 0 0 0 7px;
  max-height: 20px;
  padding: 4px 5px 4px 1px;
  align-items: center;
  display: flex;
}
.main-theme--dark .modal.currency-modal .select-list .type-item {
  display: flex;
  margin: 0 1px 0 0;
  max-width: 16px;
}
.main-theme--dark .modal.currency-modal .select-list .type-item img {
  filter: var(--filter-color-svg);
}
.main-theme--dark .modal.currency-modal .select-list .type-name {
  font-family: var(--brutal);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.5px;
  line-height: 14px;
}
.main-theme--dark .modal.currency-modal .select-list .thumbnail.symbol-bg {
  background: #232323;
  border: 1px solid var(--color-main-text);
  border-radius: 50%;
  color: var(--color-main-bg);
  height: 42px;
  max-height: 42px;
  max-width: 42px;
  min-height: 42px;
  min-width: 42px;
  overflow: hidden;
  width: 42px;
  padding: 0;
  margin-right: 12px;
}
.main-theme--dark .modal.currency-modal .select-list .thumbnail.symbol-bg img {
  height: 100%;
  width: 100%;
  background: transparent;
}
.main-theme--dark .modal.currency-modal .select-list .regular-text {
  font-size: var(--main-font-size);
  font-weight: 500;
  line-height: var(--main-font-height);
  display: flex;
  align-items: center;
}
.main-theme--dark .modal.currency-modal .select-list .body-text {
  color: var(--color-main-secondary-text);
  font-size: var(--secondary-font-size);
  line-height: var(--secondary-font-height);
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.main-theme--dark .modal.currency-modal h2 {
  display: block;
  font-family: var(--karloff);
  font-size: var(--header-font-size);
  font-weight: 400;
  line-height: var(--header-font-height);
  margin-block: 6px 10px;
  margin: 37px 0 20px;
}
@media screen and (min-width: 486px) {
  .main-theme--dark {
    max-height: 672px;
    width: var(--wrapper-width);
    border-radius: var(--border-radius-wrapper);
    box-shadow: 0 12px 40px var(--color-main-border);
  }
  .main-theme--dark .container {
    padding: 14px 26px;
    height: 100%;
  }
}

.Toastify .Toastify__toast-container {
  position: absolute;
  width: calc(100% - var(--space-content-x) * 2);
  padding: 0;
}
.Toastify .Toastify__toast-container .Toastify__toast {
  width: 100%;
  left: auto;
  box-shadow: 0 0 32px var(--color-main-border);
  -webkit-box-shadow: 0 0 32px var(--color-main-border);
  min-height: auto;
  background: var(--color-main-bg);
  border-radius: 6px;
  display: grid;
  font-size: var(--secondary-font-size);
  grid-template-columns: 1fr auto;
  line-height: var(--secondary-font-height);
  padding: 0;
}
.Toastify .Toastify__toast-container .Toastify__toast-body {
  color: var(--color-action-active);
  padding: 12px 16px;
  word-break: break-word;
}
.Toastify .Toastify__toast-container .Toastify__close-button {
  border-left: 1px solid var(--color-main-border);
  width: 40px;
  align-self: stretch;
}
.Toastify .Toastify__toast-container--top-center {
  top: 1em;
  left: 50%;
  transform: translateX(-50%);
}

.loading-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 13;
  background: var(--color-main-bg);
}
.loading-wrapper-item {
  animation: animLoading 1s ease-in-out infinite;
  background: #ffdf00;
  border-radius: 50%;
  height: 10px;
  transform: scale3d(0, 0, 0);
  transform-origin: center center;
  width: 10px;
  margin: 0 5px;
  will-change: transform;
}
.loading-wrapper-item:nth-child(2) {
  animation-delay: 0.1666666667s;
}
.loading-wrapper-item:nth-child(3) {
  animation-delay: 0.3333333333s;
}
@keyframes animLoading {
  0% {
    transform: scale3d(0, 0, 0);
  }
  50% {
    transform: scaleX(1);
  }
  100% {
    transform: scale3d(0, 0, 0);
  }
}

.incorrect-url {
  font-family: "BrutalType", serif;
  display: flex;
  align-items: center;
  margin-bottom: 50px;
  text-align: center;
  color: var(--color-encore-primary-error);
  flex-direction: column;
  height: 100%;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/assets/fonts/fonts.scss","webpack://./src/App.scss","webpack://./src/assets/styles/variables.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,0DAEA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;ACCF;ADEA;EACE,yBAAA;EACA,wLAAA;EAGA,gBAAA;EACA,kBAAA;ACFF;ADKA;EACE,yBAAA;EACA,gLAAA;EAGA,gBAAA;EACA,kBAAA;ACLF;ADQA;EACE,yBAAA;EACA,4KAAA;EAGA,iBAAA;EACA,kBAAA;ACRF;ADWA;EACE,yBAAA;EACA,4KAAA;EAGA,gBAAA;EACA,kBAAA;ACXF;ADcA;EACE,yBAAA;EACA,uLAAA;EAGA,gBAAA;EACA,kBAAA;ACdF;ADiBA;EACE,yBAAA;EACA,gLAAA;EAGA,gBAAA;EACA,kBAAA;ACjBF;ADoBA;EACE,yBAAA;EACA,gLAAA;EAGA,gBAAA;EACA,kBAAA;ACpBF;ADuBA;EACE,yBAAA;EACA,oKAAA;EAGA,mBAAA;EACA,kBAAA;ACvBF;AD0BA;EACE,sBAAA;EACA,+EAAA;EACA,mBAAA;EACA,kBAAA;ACxBF;AAzDA;EACE,oBAAA;EACA,qBAAA;AA2DF;;AAzDA;EACE,SAAA;EAEA,mCAAA;EACA,kCAAA;EAEA,gCAAA;EACA,wCAAA;EACA,+BAAA;EACA,gCAAA;EACA,YAAA;EACA,oCAAA;EACA,gBAAA;AA0DF;;AAxDA;EACE,YAAA;AA2DF;;AAzDA;EACE,SAAA;EACA,UAAA;EACA,qBAAA;EACA,qBAAA;EACA,sBAAA;AA4DF;;AAxDA;;;;;;EAME,SAAA;AA2DF;;AAxDA;EACE,8EAAA;AA2DF;;AAxDA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AA2DF;AA1DE;EAJF;IAKI,oBAAA;IACA,gBAAA;EA6DF;AACF;AA5DE;EAEI;IACE,mBAAA;EA6DN;EA3DI;IACE,oBAAA;EA6DN;AACF;;AAzDA;EACE,YAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;AA4DF;AA3DE;EACE;IACE,oBAAA;EA6DJ;AACF;AA1DE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AA4DJ;AClHI;EDwCJ;IAiBI,kBAAA;EA6DF;AACF;;AA3DA;EACE,mBAAA;EACA,iCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA8DF;;AA5DA;EACE,eAAA;AA+DF;;AA7DA;EACE,kBAAA;AAgEF;;AA9DA;EACE,eAAA;EACA,YAAA;AAiEF;;AA/DA;EAEE,aAAA;EACA,mBAAA;EACA,uBAAA;AAiEF;AA/DE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AAiEJ;;AA9DA;EACE,gBAAA;AAiEF;;AA/DA;EACE;IACE,UAAA;EAkEF;EA/DA;IACE,UAAA;EAiEF;AACF;AA9DA;EACE,wBAAA;EACA,0BAAA;EACA,oCAAA;EACA,2BAAA;EACA,iCAAA;EAEA,8BAAA;EACA,6BAAA;EACA,8BAAA;EACA,mCAAA;EACA,sCAAA;EACA,oCAAA;EACA,sCAAA;EACA,2CAAA;EAEA,qCAAA;EACA,uCAAA;EAEA,iJAAA;EACA,uJAAA;EACA,yIAAA;EAEA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,2BAAA;EACA,kCAAA;EACA,8BAAA;EACA,uCAAA;EACA,4BAAA;EACA,sBAAA;EACA,wBAAA;EACA,+BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wBAAA;EACA,0BAAA;EACA,0BAAA;EACA,wBAAA;EACA,yBAAA;EACA,sBAAA;EACA,+BAAA;EACA,6BAAA;EACA,6BAAA;EACA,uBAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;EACA,sBAAA;EACA,qBAAA;EACA,+BAAA;EACA,6BAAA;EACA,sBAAA;EACA,oBAAA;EACA,8BAAA;EACA,oCAAA;EACA,4BAAA;EACA,mCAAA;EACA,qBAAA;EACA,2BAAA;EACA,2BAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,0CAAA;EACA,wCAAA;EACA,yCAAA;AA4DF;;AAzDA;EACE;IACE,0BAAA;IACA,uBAAA;EA4DF;AACF;AAtDE;EACE,6BAAA;AAwDJ;AAvDI;EACE,kBAAA;AAyDN;AAtDE;EACE,kBAAA;AAwDJ;AAvDI;EACE,0DAAA;AAyDN;AAvDI;EACE,uCAAA;EACA,qCAAA;EACA,yCAAA;EACA,kBAAA;EACA,wCAAA;AAyDN;AAvDI;EACE,+CAAA;AAyDN;AAvDI;EACE,wCAAA;EACA,qCAAA;EACA,iBAAA;EACA,YAAA;EACA,yCAAA;EACA,oBAAA;EACA,kBAAA;EAIA,yBAAA;EAIA,oCAAA;EACA,4BAAA;AAyDN;AAtDE;EACE,YAAA;AAwDJ;AAvDI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAyDN;AAxDM;EACE,eAAA;EAEA,aAAA;AAyDR;AAvDM;EACE,gDAAA;EACA,kBAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAyDR;AAvDM;EACE,kBAAA;EACA,kBAAA;AAyDR;AAxDQ;EACE,sCAAA;EACA,wCAAA;AA0DV;AAzDU;EACE,cAAA;EACA,eAAA;AA2DZ;AAvDM;EACE,yBAAA;EACA,sBAAA;EACA,wBAAA;EACA,qBAAA;EAEA,mBAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,eAAA;EAIA,aAAA;EACA,YAAA;EAEA,uBAAA;EACA,aAAA;EACA,cAAA;EAIA,yBAAA;EAIA,6CAAA;EACA,WAAA;AAyDR;AAxDQ;EACE,aAAA;AA0DV;AAtDI;EACE,cAAA;EACA,qCAAA;EACA,gBAAA;EACA,yCAAA;EACA,iBAAA;AAwDN;AAtDI;EACE,0CAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AAwDN;AAvDM;EACE,aAAA;AAyDR;AAtDI;EACE,cAAA;EACA,2BAAA;EACA,kCAAA;EACA,gBAAA;EACA,sCAAA;EACA,sBAAA;AAwDN;AAvDM;EACE,gCAAA;EACA,2CAAA;EACA,eAAA;AAyDR;AAtDI;EACE,uCAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAwDN;AAvDM;EACE,iCAAA;EACA,eAAA;EACA,qBAAA;AAyDR;AArDE;EACE,wCAAA;AAuDJ;AApDE;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,uBAAA;EACA,iBAAA;AAsDJ;AApDI;EACE,gBAAA;AAsDN;AAnDE;EAEE,aAAA;EACA,mBAAA;AAoDJ;AAlDE;EAKE,gCAAA;EACA,6BAAA;EAIA,aAAA;EAEA,sBAAA;EACA,+BAAA;EACA,gCAAA;EACA,YAAA;EACA,oCAAA;EACA,YAAA;EAEA,gBAAA;EACA,kBAAA;EAGA,gBAAA;EACA,gBAAA;EACA,WAAA;AAiDJ;AA/CI;EACE,UAAA;AAiDN;AA9CI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAgDN;AA9CM;EACE,eAAA;AAgDR;AA5CI;EACE,wCAAA;AA8CN;AA5CI;EACE,YAAA;AA8CN;AA5CM;EACE,mBAAA;AA8CR;AA3CI;EACE,uBAAA;EACA,sBAAA;AA6CN;AA3CI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;AA6CN;AA5CM;EACE,qBAAA;AA8CR;AA1CI;EACE,eAAA;EACA,iBAAA;EACA,qBAAA;EAIA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EAEA,yCAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EAEA,2BAAA;EACA,gBAAA;AAyCN;AAvCM;EACE,iDAAA;EACA,6BAAA;EACA,eAAA;AAyCR;AApCI;EACE,cAAA;EACA,qCAAA;EACA,gBAAA;EACA,yCAAA;EACA,eAAA;AAsCN;AApCI;EAGE,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,gCAAA;EACA,2BAAA;EACA,oCAAA;EACA,SAAA;EACA,aAAA;EACA,oBAAA;EACA,mBAAA;EAIA,yBAAA;EAIA,0DAAA;EACA,WAAA;EAEA,0CAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAqCN;AAnCI;EACE,SAAA;AAqCN;AAnCI;EACE,gBAAA;AAqCN;AApCM;EACE,iBAAA;EACA,oBAAA;AAsCR;AArCQ;EACE,mBAAA;AAuCV;AApCQ;EACE,yBAAA;EAEA,aAAA;EACA,mBAAA;AAsCV;AApCU;EAIE,mBAAA;EACA,uCAAA;EACA,aAAA;EACA,eAAA;EACA,+BAAA;EACA,UAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;AAsCZ;AAjCI;EACE,6BAAA;EACA,0CAAA;EACA,iBAAA;EACA,0BAAA;EACA,2BAAA;EACA,mBAAA;EAIA,6BAAA;EACA,SAAA;EACA,0BAAA;AAmCN;AAlCM;EAIE,mBAAA;EACA,oDAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;EAIA,aAAA;EACA,YAAA;EACA,yCAAA;EACA,cAAA;EACA,kBAAA;EAKA,0BAAA;EAIA,yCAAA;AAoCR;AAnCQ;EACE,cAAA;AAqCV;AAlCM;EACE,gCAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;AAoCR;AAnCQ;EAEE,sCAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAqCV;AAjCI;EACE,0BAAA;AAmCN;AAlCM;EACE,eAAA;EACA,gBAAA;AAoCR;AAjCI;EACE,sCAAA;EACA,kBAAA;EACA,2BAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,gCAAA;EACA,gCAAA;EACA,kBAAA;EAIA,iCAAA;EACA,WAAA;AAmCN;AAlCM;EACE,2CAAA;AAoCR;AAlCM;EACE,4CAAA;EACA,eAAA;AAoCR;AA/BM;EACE,gCAAA;EAEA,2CAAA;EACA,YAAA;EACA,gBAAA;AAiCR;AAhCQ;EACE,kBAAA;EACA,cAAA;EACA,UAAA;EACA,oCAAA;EACA,UAAA;EACA,MAAA;AAkCV;AA/BM;EACE,oCAAA;EACA,gBAAA;AAiCR;AA/BM;EACE,aAAA;EACA,iDAAA;EACA,YAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;AAiCR;AAhCQ;EACE,mBAAA;AAkCV;AAhCU;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,wBAAA;AAkCZ;AA/BU;EACE,UAAA;AAiCZ;AA9BQ;EACE,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,gCAAA;EACA,2BAAA;EACA,oCAAA;EACA,SAAA;EACA,aAAA;EACA,oBAAA;AAgCV;AA7BM;EACE,gCAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,aAAA;EACA,oBAAA;EACA,iBAAA;AA+BR;AA7BQ;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,wBAAA;AA+BV;AA5BQ;EACE,UAAA;AA8BV;AA1BQ;EACE,aAAA;EAIA,mBAAA;EACA,iDAAA;EACA,aAAA;EACA,oCAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AA4BV;AA1BU;EACE,WAAA;AA4BZ;AA3BY;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AA6Bd;AAxBM;EACE,iBAAA;EACA,eAAA;AA0BR;AAtBI;EACE,uBAAA;EACA,iBAAA;AAwBN;AAvBM;EACE,eAAA;EACA,iBAAA;AAyBR;AAvBM;EACE,WAAA;AAyBR;AAvBM;EACE,YAAA;EACA,eAAA;EAKA,0BAAA;EACA,WAAA;AAyBR;AAtBI;;EAEE,QAAA;AAwBN;AArBM;EACE,oCAAA;EACA,0CAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AAuBR;AAtBQ;EACE,WAAA;EACA,YAAA;AAwBV;AAnBM;EACE,SAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;AAqBR;AApBQ;EACE,aAAA;EACA,YAAA;AAsBV;AApBU;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,wBAAA;AAsBZ;AAnBU;EACE,UAAA;AAqBZ;AAjBM;EACE,mBAAA;EACA,wCAAA;EACA,kBAAA;EACA,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAmBR;AAjBM;EACE,QAAA;AAmBR;AAjBM;EACE,cAAA;EACA,WAAA;EACA,QAAA;AAmBR;AAhBQ;EACE,cAAA;AAkBV;AAdM;EACE,iBAAA;EACA,mCAAA;AAgBR;AAfQ;EACE,oBAAA;AAiBV;AAdM;EACE,0BAAA;EACA,qCAAA;EACA,gBAAA;EACA,yCAAA;EACA,gBAAA;AAgBR;AAbQ;EACE,0CAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA;EAIA,mBAAA;EAIA,aAAA;AAeV;AAdU;EACE,aAAA;EACA,iBAAA;EACA,eAAA;AAgBZ;AAfY;EAEE,+BAAA;AAiBd;AAdU;EACE,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;AAgBZ;AAbQ;EACE,mBAAA;EACA,wCAAA;EACA,kBAAA;EACA,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;AAeV;AAdU;EACE,YAAA;EACA,WAAA;EACA,uBAAA;AAgBZ;AAbQ;EACE,gCAAA;EACA,gBAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;AAeV;AAbQ;EACE,uCAAA;EACA,qCAAA;EACA,yCAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAeV;AAZM;EACE,cAAA;EACA,2BAAA;EACA,kCAAA;EACA,gBAAA;EACA,sCAAA;EACA,sBAAA;EACA,mBAAA;AAcR;ACn7BI;ED0WF;IAgkBI,iBAAA;IACA,2BAAA;IACA,2CAAA;IAEA,gDAAA;EAaJ;EAXI;IACE,kBAAA;IACA,YAAA;EAaN;AACF;;AAJE;EACE,kBAAA;EAGA,8CAAA;EACA,UAAA;AAOJ;AANI;EACE,WAAA;EACA,UAAA;EACA,6CAAA;EACA,qDAAA;EACA,gBAAA;EACA,gCAAA;EACA,kBAAA;EACA,aAAA;EACA,qCAAA;EACA,+BAAA;EACA,yCAAA;EACA,UAAA;AAQN;AAPM;EACE,iCAAA;EACA,kBAAA;EACA,sBAAA;AASR;AANI;EACE,+CAAA;EACA,WAAA;EACA,mBAAA;AAQN;AALE;EACE,QAAA;EACA,SAAA;EACA,2BAAA;AAOJ;;AAFA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,gCAAA;AAKF;AAJE;EAGE,8CAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EAGA,2BAAA;EAKA,+BAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AAMJ;AALI;EAGE,8BAAA;AAON;AALI;EAGE,8BAAA;AAON;AAJE;EACE;IAGE,2BAAA;EAMJ;EAJE;IAGE,oBAAA;EAMJ;EAJE;IAGE,2BAAA;EAMJ;AACF;;AAFA;EACE,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,wCAAA;EACA,sBAAA;EACA,YAAA;EACA,uBAAA;AAKF","sourcesContent":["@font-face {\n  font-family: 'SF-Compact';\n  src:\n          //url('./square721-bt/sqr721b.woff2') format('woff2'),\n  url('./SF-Compact-Text-Bold.ttf') format('ttf');\n  font-weight: 700;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'BrutalType';\n  src: local('BrutalType-ExtraLight'), local('BrutalType-ExtraLight'),\n  url('brutal-font/BrutalType-ExtraLight.woff2') format('woff2'),\n  url('brutal-font/BrutalType-ExtraLight.ttf') format('truetype');\n  font-weight: 200;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'BrutalType';\n  src: local('BrutalType-Medium'), local('BrutalType-Medium'),\n  url('brutal-font/BrutalType-Medium.woff2') format('woff2'),\n  url('brutal-font/BrutalType-Medium.ttf') format('truetype');\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'BrutalType';\n  src: local('BrutalType-Bold'), local('BrutalType-Bold'),\n  url('brutal-font/BrutalType-Bold.woff2') format('woff2'),\n  url('brutal-font/BrutalType-Bold.ttf') format('truetype');\n  font-weight: bold;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'BrutalType';\n  src: local('BrutalType-Thin'), local('BrutalType-Thin'),\n  url('brutal-font/BrutalType-Thin.woff2') format('woff2'),\n  url('brutal-font/BrutalType-Thin.ttf') format('truetype');\n  font-weight: 100;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'BrutalType';\n  src: local('BrutalType-ExtraBold'), local('BrutalType-ExtraBold'),\n  url('brutal-font/BrutalType-ExtraBold.woff2') format('woff2'),\n  url('brutal-font/BrutalType-ExtraBold.ttf') format('truetype');\n  font-weight: 800;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'BrutalType';\n  src: local('BrutalType-Black'), local('BrutalType-Black'),\n  url('brutal-font/BrutalType-Black.woff2') format('woff2'),\n  url('brutal-font/BrutalType-Black.ttf') format('truetype');\n  font-weight: 900;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'BrutalType';\n  src: local('BrutalType-Light'), local('BrutalType-Light'),\n  url('brutal-font/BrutalType-Light.woff2') format('woff2'),\n  url('brutal-font/BrutalType-Light.ttf') format('truetype');\n  font-weight: 300;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'BrutalType';\n  src: local('BrutalType'), local('BrutalType'),\n  url('brutal-font/BrutalType.woff2') format('woff2'),\n  url('brutal-font/BrutalType.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Karloff';\n  src: local('Karloff'), url('Karloff/Karloff-Neutral-Regular-Web.woff2') format('woff2');\n  font-weight: normal;\n  font-style: normal;\n}\n\n\n//@font-face {\n//  font-family: 'Square721-BT';\n//  src: url('./square721-bt/Squ721Rm.woff2') format('woff2'), url('./square721-bt/Squ721Rm.ttf') format('ttf');\n//  font-weight: 500;\n//  font-style: normal;\n//  font-display: swap;\n//}\n//@font-face {\n//  font-family: 'Square721-BT';\n//  src: url('./square721-bt/TT0246M_.woff2') format('woff2'), url('./square721-bt/TT0246M_.ttf') format('ttf');;\n//  font-weight: 400;\n//  font-style: normal;\n//  font-display: swap;\n//}\n","@import \"src/assets/styles/variables\";\n@import 'assets/fonts/fonts';\n//@import 'react-toastify/dist/ReactToastify.css';\n\n\n:root{\n  --headerHeight: 64px;\n  --sidebarWidth: 266px;\n}\nbody {\n  margin: 0;\n  //font-family: $montserrat;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  background: var(--color-main-bg);\n  color: var(--color-main-text)!important;\n  font-family: var(--font-family);\n  font-size: var(--main-font-size);\n  height: 100%;\n  line-height: var(--main-font-height);\n  overflow: hidden;\n}\nhtml, body, #root{\n  height: 100%;\n}\n* {\n  margin: 0;\n  padding: 0;\n  text-decoration: none;\n  list-style-type: none;\n  box-sizing: border-box;\n}\n\n//HEADINGS\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0;\n}\n\nbody{\n  background: radial-gradient(101.77% 75.82% at 50% 43%,#292201 0,#000 55.45%);\n}\n\n#root{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  @media screen and (((min-width: 576px) and (min-height: 830px)) or (orientation: landscape)) {\n    padding: 70px 0 10px;\n    min-height: 100%;\n  }\n  @media screen and (orientation: landscape) and (max-height: 600px){\n    .main-theme--dark {\n      .container{\n        margin-bottom: 70px;\n      }\n      footer{\n        padding-bottom: 16px;\n      }\n    }\n  }\n}\nmain{\n  height: 100%;\n  width: 100%;\n  background-color: #fff;\n  overflow: hidden;\n  @media screen and (orientation: landscape) {\n    .form-actions {\n      padding-bottom: 20px;\n    }\n  }\n  //position: relative;\n  .section{\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n  @include screen(md){\n    position: relative;\n  }\n}\n.outlined-btn{\n  border-radius: 16px;\n  background: rgba(35, 58, 64, 0.10);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.pointer{\n  cursor: pointer;\n}\n.text-center{\n  text-align: center;\n}\n.img-fluid{\n  max-width: 100%;\n  height: auto;\n}\n.thumbnail{\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img{\n    width: 32px;\n    height: 32px;\n    border-radius: 10px;\n    overflow: hidden;\n    object-fit: cover;\n  }\n}\n.bold{\n  font-weight: 700;\n}\n@keyframes fadeInAnim {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n:root {\n  --color-main-bg: #000000;\n  --color-main-text: #ffffff;\n  --color-main-secondary-text: #9d9d9d;\n  --color-main-border:#d3d3d3;\n  --color-main-secondary-bg:#232323;\n\n  --color-action-active: #FFDF00;\n  --color-action-hover: #E4D200;\n  --color-action-tapped: #ffe845;\n  --color-action-link-hovered:#ffea57;\n  --color-action-disabled-small: #c4c4c4;\n  --color-action-disabled-big: #fff9cc;\n  --color-action-select-borders: #fff9cc;\n  --color-action-small-round-buttons: #FFF6EB;\n\n  --color-encore-primary-error: #ff3838;\n  --color-encore-secondary-error: #8f2323;\n\n  --filter-color-action-svg: brightness(0) saturate(100%) invert(91%) sepia(17%) saturate(3852%) hue-rotate(357deg) brightness(100%) contrast(105%);\n  --filter-color-error-primary-svg: brightness(0) saturate(100%) invert(30%) sepia(87%) saturate(1709%) hue-rotate(338deg) brightness(98%) contrast(106%);\n  --filter-color-svg: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7437%) hue-rotate(32deg) brightness(116%) contrast(106%);\n\n  --header-height: 48px;\n  --button-height: 48px;\n  --input-height: 52px;\n  --karloff: 'Karloff', serif;\n  --brutal: 'BrutalType', sans-serif;\n  --roboto: 'Roboto', sans-serif;\n  --roboto-mono: 'Roboto Mono', monospace;\n  --font-family: var(--brutal);\n  --main-font-size: 17px;\n  --main-font-height: 24px;\n  --description-font-height: 21px;\n  --secondary-font-size: 14px;\n  --secondary-font-height: 17px;\n  --header-font-size: 28px;\n  --header-font-height: 32px;\n  --max-content-width: 600px;\n  --max-modal-width: 660px;\n  --max-button-width: 352px;\n  --wrapper-width: 432px;\n  --metamask-wrapper-width: 448px;\n  --border-radius-wrapper: 24px;\n  --metamask-border-radius: 8px;\n  --space-content-x: 24px;\n  --space-center-modal-x: 16px;\n  --space-content-wrapper: 66px;\n  --z-index-header-modal: 100;\n  --z-index-cookies: 101;\n  --z-index-header: 102;\n  --z-index-desktop-modal-bg: 103;\n  --z-index-desktop-select: 104;\n  --z-index-tooltip: 105;\n  --z-index-modal: 106;\n  --z-index-converter-modal: 107;\n  --z-index-currency-select-modal: 108;\n  --z-index-country-modal: 109;\n  --z-index-country-select-modal: 110;\n  --z-index-loader: 111;\n  --z-index-notification: 112;\n  --z-index-global-error: 113;\n  --z-index-landing: 114;\n  --z-index-global-modal: 115;\n  --z-index-intercom: 116;\n  --input-error-animation: I8IGq 6s forwards;\n  --burger-line-open-animation-name: _F1_a;\n  --burger-line-close-animation-name: FjdJQ;\n}\n\n@media (max-height: 672px), (max-width: 486px){\n  :root {\n    --space-content-wrapper: 0;\n    --space-content-x: 16px;\n  }\n\n}\n\n//NEW THEME\n.main-theme{\n  .header{\n    background-color: transparent;\n    .navbar-toggler{\n      margin-right: -4px;\n    }\n  }\n  .has-error{\n    position: relative;\n    .form-control{\n      border-color: var(--color-encore-primary-error)!important;\n    }\n    .error-message{\n      animation: var(--input-error-animation);\n      font-size: var(--secondary-font-size);\n      line-height: var(--secondary-font-height);\n      padding: 4px 0 8px;\n      color: var(--color-encore-primary-error);\n    }\n    .thumbnail.symbol-bg{\n      border-color: var(--color-encore-primary-error);\n    }\n    .error-message.pos{\n      color: var(--color-encore-primary-error);\n      font-size: var(--secondary-font-size);\n      grid-column: 1 / -1;\n      height: 30px;\n      line-height: var(--secondary-font-height);\n      margin: -21px 0 10px;\n      padding: 8px 0 3px;\n      -webkit-transition-duration: .2s;\n      -moz-transition-duration: .2s;\n      -o-transition-duration: .2s;\n      transition-duration: .2s;\n      -webkit-transition-property: height,padding;\n      -o-transition-property: height,padding;\n      -moz-transition-property: height,padding;\n      transition-property: height,padding;\n      will-change: height,padding;\n    }\n  }\n  .complete-form{\n    height: 100%;\n    .email-agree {\n      display: flex;\n      align-items: center;\n      flex-wrap: wrap;\n      margin-top: 16px;\n      .text{\n        font-size: 14px;\n        //line-height: 17px;\n        margin:0 4px;\n      }\n      .optional-label{\n        background-color: var(--color-main-secondary-bg);\n        border-radius: 3px;\n        color: var(--color-main-secondary-text);\n        font-size: 12px;\n        font-weight: 500;\n        line-height: 13px;\n        padding: 2px 5px;\n      }\n      .email-agree-input{\n        visibility: hidden;\n        position: absolute;\n        &:checked + .border{\n          background: var(--color-action-active);\n          border-color: var(--color-action-active);\n          svg{\n            display: block;\n            min-width: 16px;\n          }\n        }\n      }\n      .border{\n        -webkit-box-align: center;\n        -moz-box-align: center;\n        -webkit-box-pack: center;\n        -moz-box-pack: center;\n        -webkit-align-items: center;\n        align-items: center;\n        background: inherit;\n        border: 1px solid var(--color-main-border);\n        border-radius: 4px;\n        cursor: pointer;\n        display: -webkit-box;\n        display: -webkit-flex;\n        display: -moz-box;\n        display: flex;\n        height: 16px;\n        -webkit-justify-content: center;\n        justify-content: center;\n        outline: none;\n        padding: 0 2px;\n        -webkit-transition-duration: .2s;\n        -moz-transition-duration: .2s;\n        -o-transition-duration: .2s;\n        transition-duration: .2s;\n        -webkit-transition-property: background,border-color;\n        -o-transition-property: background,border-color;\n        -moz-transition-property: background,border-color;\n        transition-property: background,border-color;\n        width: 16px;\n        svg{\n          display: none;\n        }\n      }\n    }\n    .regular-label{\n      display: block;\n      font-size: var(--secondary-font-size);\n      font-weight: 500;\n      line-height: var(--secondary-font-height);\n      margin: 2px 0 8px;\n    }\n    .form-control{\n      border: 1px solid var(--color-main-border);\n      border-radius: 8px;\n      padding: 13px 16px;\n      color: #fff;\n      &:focus{\n        outline: none;\n      }\n    }\n    .headings .complete-title{\n      display: block;\n      font-family: var(--karloff);\n      font-size: var(--header-font-size);\n      font-weight: 400;\n      line-height: var(--header-font-height);\n      margin-block: 6px 10px;\n      + .description{\n        font-size: var(--main-font-size);\n        line-height: var(--description-font-height);\n        margin: 0 0 5px;\n      }\n    }\n    .terms-text{\n      color: var(--color-main-secondary-text);\n      font-size: 14px;\n      line-height: 17px;\n      text-align: center;\n      margin-top: 16px;\n      a{\n        color: var(--color-action-active);\n        cursor: pointer;\n        text-decoration: none;\n      }\n    }\n  }\n  .container{\n    height: calc(100% - var(--headerHeight));\n    //height: 100%;\n  }\n  .sidebar__list{\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    height: 80%;\n    justify-content: center;\n    padding-top: 60px;\n\n    .heading-2{\n      font-weight: 400;\n    }\n  }\n  .logo-wrapper{\n    //filter: brightness(0) invert(1);\n    display: flex;\n    align-items: center;\n  }\n  &--dark{\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -moz-box-orient: vertical;\n    -moz-box-direction: normal;\n    background: var(--color-main-bg);\n    color: var(--color-main-text);\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -moz-box;\n    display: flex;\n    -webkit-flex-direction: column;\n    flex-direction: column;\n    font-family: var(--font-family);\n    font-size: var(--main-font-size);\n    height: 100%;\n    line-height: var(--main-font-height);\n    margin: auto;\n\n    overflow: hidden;\n    position: relative;\n\n\n    border-radius: 0;\n    max-height: 100%;\n    width: 100%;\n\n    .btn--icon:not(:disabled):not(:focus):hover{\n      opacity: 1;\n    }\n\n    .widget-header{\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n\n      .back-action {\n        cursor: pointer;\n      }\n    }\n\n    .container{\n      padding: 4px var(--space-content-x) 22px;\n    }\n    .widget-container{\n      height: 100%;\n\n      iframe {\n        border-radius: 24px;\n      }\n    }\n    .transparent{\n      background: transparent;\n      vertical-align: middle;\n    }\n    .flexed-wrapper{\n      display: flex;\n      align-items: center;\n      font-size: 25px;\n      line-height: 27px;\n      margin-block: 7px;\n      width: 100%;\n      &.page-title{\n        margin-block: 9px 7px;\n      }\n    }\n\n    .buy-sell-btn{\n      font-size: 25px;\n      line-height: 27px;\n      margin-block: 9px 7px;\n\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      background: none;\n      border: none;\n      cursor: pointer;\n      outline: none;\n      width: auto;\n\n      border-bottom: 1px solid rgba(0,0,0,0);\n      color: var(--color-main-secondary-text);\n      margin: 0 17px 0 0;\n      padding: 0 0 4px;\n\n      font-family: var(--karloff);\n      font-weight: 400;\n\n      &.selected{\n        border-bottom: 1px solid var(--color-main-border);\n        color: var(--color-main-text);\n        cursor: default;\n      }\n\n    }\n\n    .regular-label{\n      display: block;\n      font-size: var(--secondary-font-size);\n      font-weight: 500;\n      line-height: var(--secondary-font-height);\n      margin-top: 2px;\n    }\n    .form-input.form-control .form-control{\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      background: inherit;\n      border: none;\n      color: inherit;\n      font-family: inherit;\n      font-size: var(--main-font-size);\n      height: var(--input-height);\n      line-height: var(--main-font-height);\n      margin: 0;\n      outline: none;\n      padding: 13px 0 11px;\n      text-align: inherit;\n      -webkit-transition-duration: .2s;\n      -moz-transition-duration: .2s;\n      -o-transition-duration: .2s;\n      transition-duration: .2s;\n      -webkit-transition-property: background-color,color,border-color;\n      -o-transition-property: background-color,color,border-color;\n      -moz-transition-property: background-color,color,border-color;\n      transition-property: background-color,color,border-color;\n      width: 100%;\n\n      border: 1px solid var(--color-main-border);\n      border-radius: 8px 0 0 8px;\n      padding: 13px 16px;\n      font-weight: 400;\n      border-right: 0;\n    }\n    .form-input{\n      flex: 1;\n    }\n    .main-form{\n      margin: 21px 0 0;\n      &.second-form{\n        margin: 5px 0 0 0;\n        padding-bottom: 42px;\n        .accordion{\n          margin: auto 0 20px;\n        }\n\n        .wallet-input-container {\n          -webkit-box-align: center;\n          display: -webkit-flex;\n          display: flex;\n          align-items: center;\n\n          .wallet-placeholder {\n            -webkit-box-align: center;\n            -moz-box-align: center;\n            -webkit-align-items: center;\n            align-items: center;\n            color: var(--color-main-secondary-text);\n            display: grid;\n            font-size: 15px;\n            grid-template-columns: 1fr auto;\n            left: 16px;\n            line-height: 24px;\n            pointer-events: none;\n            position: absolute;\n          }\n        }\n      }\n    }\n    .thumbnail.symbol-bg{\n      background-color: transparent;\n      border: 1px solid var(--color-main-border);\n      border-left: none;\n      border-radius: 0 8px 8px 0;\n      height: var(--input-height);\n      padding-right: 10px;\n      -webkit-transition: border-color .2s;\n      -o-transition: border-color .2s;\n      -moz-transition: border-color .2s;\n      transition: border-color .2s;\n      margin: 0;\n      font-family: var(--brutal);\n      .sign{\n        -webkit-box-align: center;\n        -moz-box-align: center;\n        -webkit-align-items: center;\n        align-items: center;\n        border: 1px solid var(--color-action-select-borders);\n        border-radius: 3px;\n        font-size: 17px;\n        font-weight: 400;\n        min-width: 47px;\n        color: var(--color-action-active);\n        display: -webkit-box;\n        display: -webkit-flex;\n        display: -moz-box;\n        display: flex;\n        height: 24px;\n        line-height: var(--secondary-font-height);\n        padding: 0 6px;\n        position: relative;\n        -webkit-transform: translateY(1px);\n        -moz-transform: translateY(1px);\n        -ms-transform: translateY(1px);\n        -o-transform: translateY(1px);\n        transform: translateY(1px);\n        -webkit-transition: border-color .2s,color .2s;\n        -o-transition: border-color .2s,color .2s;\n        -moz-transition: border-color .2s,color .2s;\n        transition: border-color .2s,color .2s;\n        span{\n          margin: 0 auto;\n        }\n      }\n      .crypto-icon{\n        background: var(--color-main-bg);\n        border-radius: 50%;\n        height: auto;\n        position: absolute;\n        right: -9px;\n        top: -10px;\n        width: 15px;\n        z-index: 1;\n        img{\n          -webkit-filter: var(--filter-color-action-svg);\n          filter: var(--filter-color-action-svg);\n          width: 100%;\n          height: 100%;\n          border-radius: 0;\n        }\n      }\n    }\n    .btn{\n      font-family: var(--brutal);\n      .regular-text{\n        font-size: 17px;\n        font-weight: 700;\n      }\n    }\n    .submit-btn.btn--primary{\n      background: var(--color-action-active);\n      border-radius: 8px;\n      color: var(--color-main-bg);\n      display: inline-block;\n      font-weight: 700;\n      height: 100%;\n      max-height: var(--button-height);\n      min-height: var(--button-height);\n      text-align: center;\n      -webkit-transition: background-color .2s;\n      -o-transition: background-color .2s;\n      -moz-transition: background-color .2s;\n      transition: background-color .2s;\n      width: 100%;\n      &:hover:not(:disabled):not(:active) {\n        background-color: var(--color-action-hover);\n      }\n      &:disabled {\n        background: var(--color-action-disabled-big);\n        cursor: default;\n      }\n    }\n\n    .modal{\n      &__content{\n        background: var(--color-main-bg);\n        -webkit-box-shadow: 0 12px 32px rgba(0,0,0,.03);\n        box-shadow: 0 12px 32px rgba(0,0,0,.03);\n        height: 100%;\n        border-radius: 0;\n        .btn{\n          position: absolute;\n          z-index: 99999;\n          left: auto;\n          padding: 18px var(--space-content-x);\n          right: 6px;\n          top: 0;\n        }\n      }\n      &__content__body{\n        padding: 16px var(--space-content-x);\n        max-height: 100%;\n      }\n      .search-wrapper{\n        z-index: 9999;\n        border-bottom: 1px solid var(--color-main-border);\n        height: 48px;\n        background: var(--color-main-bg);\n        margin-bottom: 0;\n        position: unset;\n        .form-input--search{\n          padding: 0 0 0 28px;\n\n          &::before {\n            z-index: -1;\n            content: '';\n            position: absolute;\n            top: 0;\n            left: -14px;\n            width: 108.5%;\n            height: 100%;\n            background: #000000;\n            opacity: 1;\n            transition: opacity 0.3s;\n          }\n\n          &:hover::before {\n            opacity: 1;\n          }\n        }\n        .form-control{\n          appearance: none;\n          background: inherit;\n          border: none;\n          color: inherit;\n          font-family: inherit;\n          font-size: var(--main-font-size);\n          height: var(--input-height);\n          line-height: var(--main-font-height);\n          margin: 0;\n          outline: none;\n          padding: 13px 0 11px;\n        }\n      }\n      .modal-heading{\n        background: var(--color-main-bg);\n        position: sticky;\n        margin-top: -24px;\n        top: -24px;\n        z-index: 9999;\n        padding-bottom: 14px;\n        padding-top: 50px;\n\n        &::before {\n          z-index: -1;\n          content: '';\n          position: absolute;\n          top: 0;\n          left: -14px;\n          width: 108.5%;\n          height: 100%;\n          background: #000000;\n          opacity: 1;\n          transition: opacity 0.3s;\n        }\n\n        &:hover::before {\n          opacity: 1;\n        }\n      }\n      .select-list{\n        &__item{\n          grid-gap: 8px;\n          -webkit-box-align: center;\n          -moz-box-align: center;\n          -webkit-align-items: center;\n          align-items: center;\n          border-bottom: 1px solid var(--color-main-border);\n          display: grid;\n          grid-template-columns: auto 1fr auto;\n          padding: 8px 0;\n          position: relative;\n          border-radius: 0;\n          margin-bottom: 0;\n\n          .content{\n            color: #fff;\n            .regular-text{\n              max-width: 100%;\n              overflow: hidden;\n              text-overflow: ellipsis;\n              white-space: nowrap;\n              color: currentColor;\n              font-size: 17px;\n            }\n          }\n        }\n      }\n      .descr{\n        line-height: 21px;\n        margin: 5px 0 0;\n      }\n    }\n\n    footer{\n      margin-block: auto -1px;\n      padding-top: 10px;\n      .by{\n        font-size: 14px;\n        line-height: 17px;\n      }\n      a{\n        color: #fff;\n      }\n      .powered-by{\n        height: 12px;\n        max-width: 82px;\n        -webkit-transform: translateY(4px);\n        -moz-transform: translateY(4px);\n        -ms-transform: translateY(4px);\n        -o-transform: translateY(4px);\n        transform: translateY(4px);\n        width: 100%;\n      }\n    }\n    .form-input .search-icon,\n    .form-input .voice-icon {\n      top: 44%;\n    }\n    .modal.country-modal{\n      .thumbnail{\n        background: var(--color-main-border);\n        border: 1px solid var(--color-main-border);\n        border-radius: 50%;\n        height: 31px;\n        width: 31px;\n        overflow: hidden;\n        img{\n          width: 100%;\n          height: 100%;\n        }\n      }\n    }\n    .modal.currency-modal{\n      .search-wrapper{\n        margin: 0;\n        position: sticky;\n        top: -60px;\n        z-index: 9999;\n        height: auto;\n        margin-top: 42px;\n        .form-input--search{\n          z-index: 9999;\n          height: 44px;\n\n          &::before {\n            z-index: -1;\n            content: '';\n            position: absolute;\n            top: 0;\n            left: -14px;\n            width: 108.5%;\n            height: 100%;\n            background: #000000;\n            opacity: 1;\n            transition: opacity 0.3s;\n          }\n\n          &:hover::before {\n            opacity: 1;\n          }\n        }\n      }\n      .thumbnail img{\n        background: #232323;\n        border: 1px solid var(--color-main-text);\n        border-radius: 50%;\n        color: var(--color-main-bg);\n        height: 42px;\n        max-height: 42px;\n        max-width: 42px;\n        min-height: 42px;\n        min-width: 42px;\n        overflow: hidden;\n        width: 42px;\n      }\n      .form-input .search-icon, .form-input .voice-icon {\n        top: 47%;\n      }\n      .modal__content .btn {\n        z-index: 99999;\n        right: -2px;\n        top: 4px;\n      }\n      .select-list {\n        &__item {\n          grid-gap: 12px;\n        }\n      }\n\n      .list{\n        padding: 19px 0 0;\n        scroll-margin: var(--scroll-margin);\n        &:last-of-type{\n          padding-bottom: 60px;\n        }\n      }\n      .fiat{\n        font-family: var(--brutal);\n        font-size: var(--secondary-font-size);\n        font-weight: 500;\n        line-height: var(--secondary-font-height);\n        margin: 0 0 13px;\n      }\n      .select-list{\n        .type{\n          border: 1px solid var(--color-main-border);\n          border-radius: 3px;\n          margin: 0 0 0 7px;\n          max-height: 20px;\n          padding: 4px 5px 4px 1px;\n          -webkit-box-align: center;\n          -moz-box-align: center;\n          -webkit-align-items: center;\n          align-items: center;\n          display: -webkit-box;\n          display: -webkit-flex;\n          display: -moz-box;\n          display: flex;\n          &-item{\n            display: flex;\n            margin: 0 1px 0 0;\n            max-width: 16px;\n            img{\n              -webkit-filter: var(--filter-color-svg);\n              filter: var(--filter-color-svg);\n            }\n          }\n          &-name{\n            font-family: var(--brutal);\n            font-size: 12px;\n            font-weight: 500;\n            letter-spacing: .5px;\n            line-height: 14px;\n          }\n        }\n        .thumbnail.symbol-bg{\n          background: #232323;\n          border: 1px solid var(--color-main-text);\n          border-radius: 50%;\n          color: var(--color-main-bg);\n          height: 42px;\n          max-height: 42px;\n          max-width: 42px;\n          min-height: 42px;\n          min-width: 42px;\n          overflow: hidden;\n          width: 42px;\n          padding: 0;\n          margin-right: 12px;\n          img{\n            height: 100%;\n            width: 100%;\n            background: transparent;\n          }\n        }\n        .regular-text{\n          font-size: var(--main-font-size);\n          font-weight: 500;\n          line-height: var(--main-font-height);\n          display: flex;\n          align-items: center;\n        }\n        .body-text{\n          color: var(--color-main-secondary-text);\n          font-size: var(--secondary-font-size);\n          line-height: var(--secondary-font-height);\n          font-weight: 400;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n        }\n      }\n      h2{\n        display: block;\n        font-family: var(--karloff);\n        font-size: var(--header-font-size);\n        font-weight: 400;\n        line-height: var(--header-font-height);\n        margin-block: 6px 10px;\n        margin: 37px 0 20px;\n      }\n    }\n\n    @include screen(xs) {\n      max-height: 672px;\n      width: var(--wrapper-width);\n      border-radius: var(--border-radius-wrapper);\n      -webkit-box-shadow: 0 12px 40px var(--color-main-border);\n      box-shadow: 0 12px 40px var(--color-main-border);\n\n      .container{\n        padding: 14px 26px;\n        height: 100%;\n      }\n    }\n  }\n\n}\n\n//TOASTER CUSTOM\n.Toastify {\n  //position: absolute;\n  .Toastify__toast-container{\n    position: absolute;\n    width: -webkit-calc(100% - var(--space-content-x)*2);\n    width: -moz-calc(100% - var(--space-content-x)*2);\n    width: calc(100% - var(--space-content-x)*2);\n    padding: 0;\n    .Toastify__toast{\n      width: 100%;\n      left: auto;\n      box-shadow: 0 0 32px var(--color-main-border);\n      -webkit-box-shadow: 0 0 32px var(--color-main-border);\n      min-height: auto;\n      background: var(--color-main-bg);\n      border-radius: 6px;\n      display: grid;\n      font-size: var(--secondary-font-size);\n      grid-template-columns: 1fr auto;\n      line-height: var(--secondary-font-height);\n      padding: 0;\n      &-body{\n        color: var(--color-action-active);\n        padding: 12px 16px;\n        word-break: break-word;\n      }\n    }\n    .Toastify__close-button{\n      border-left: 1px solid var(--color-main-border);\n      width: 40px;\n      align-self: stretch;\n    }\n  }\n  .Toastify__toast-container--top-center {\n    top: 1em;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n}\n\n\n.loading-wrapper{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 13;\n  background: var(--color-main-bg);\n  &-item{\n    -webkit-animation: animLoading 1s ease-in-out infinite;\n    -moz-animation: animLoading 1s ease-in-out infinite;\n    animation: animLoading 1s ease-in-out infinite;\n    background: #ffdf00;\n    border-radius: 50%;\n    height: 10px;\n    -webkit-transform: scale3d(0, 0, 0);\n    -moz-transform: scale3d(0, 0, 0);\n    transform: scale3d(0, 0, 0);\n    -webkit-transform-origin: center center;\n    -moz-transform-origin: center center;\n    -ms-transform-origin: center center;\n    -o-transform-origin: center center;\n    transform-origin: center center;\n    width: 10px;\n    margin: 0 5px;\n    will-change: transform;\n    &:nth-child(2){\n      -webkit-animation-delay: .1666666667s;\n      -moz-animation-delay: .1666666667s;\n      animation-delay: .1666666667s;\n    }\n    &:nth-child(3){\n      -webkit-animation-delay: .3333333333s;\n      -moz-animation-delay: .3333333333s;\n      animation-delay: .3333333333s;\n    }\n  }\n  @keyframes animLoading {\n    0% {\n      -webkit-transform: scale3d(0, 0, 0);\n      -moz-transform: scale3d(0, 0, 0);\n      transform: scale3d(0, 0, 0);\n    }\n    50% {\n      -webkit-transform: scaleX(1);\n      -moz-transform: scaleX(1);\n      transform: scaleX(1);\n    }\n    100% {\n      -webkit-transform: scale3d(0, 0, 0);\n      -moz-transform: scale3d(0, 0, 0);\n      transform: scale3d(0, 0, 0);\n    }\n  }\n}\n\n.incorrect-url {\n  font-family: 'BrutalType', serif;\n  display: flex;\n  align-items: center;\n  margin-bottom: 50px;\n  text-align: center;\n  color: var(--color-encore-primary-error);\n  flex-direction: column;\n  height: 100%;\n  justify-content: center;\n}\n","@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@500;700&display=swap');\n\n@import \"color-variables\";\n\n$intel: 'Inter', sans-serif;\n$montserrat: 'Montserrat', sans-serif;\n$sfCompact: 'SF-Compact', sans-serif;\n$brutalType: 'BrutalType', sans-serif;\n\n// BREAKPOINTS\n$media-xs: 486px;\n$media-sm: 768px;\n$media-md: 1024px;\n$media-lg: 1200px;\n$media-xl: 1440px;\n\n@mixin screen($size, $type: min, $pixels: $media-xs) {\n  @if $size == \"xs\" {\n    @media screen and ($type + -width: $media-xs) {\n      @content;\n    }\n  } @else if $size == \"sm\" {\n    @media screen and ($type + -width: $media-sm) {\n      @content;\n    }\n  } @else if $size == \"md\" {\n    @media screen and ($type + -width: $media-md) {\n      @content;\n    }\n  } @else if $size == \"lg\" {\n    @media screen and ($type + -width: $media-lg) {\n      @content;\n    }\n  } @else if $size == \"xlg\" {\n    @media screen and ($type + -width: $media-xl) {\n      @content;\n    }\n  } @else if $size == \"custom\" {\n    @media screen and ($type + -width: $pixels + px) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n//BETWEEN BREAKPOINTS\n@mixin media-breakpoint-between($minW, $maxW) {\n  @media screen and (min-width: $minW - 1px) and (max-width: $maxW) {\n    @content;\n  }\n}\n\n@mixin fontVariation($size: \"16px\", $weight: \"500\", $lineHeight: \"20px\") {\n  font-size: $size;\n  line-height: $weight;\n  font-weight: $lineHeight;\n}\n\n@mixin lineClamp($line) {\n  display: -webkit-box;\n  -webkit-line-clamp: #{$line};\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n@mixin scrollBar($width, $height) {\n  &::-webkit-scrollbar {\n    width: $width;\n    height: $height;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #e1e6ec;\n    border-radius: 8px;\n  }\n}\n\n%positioned {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n}\n\n%flex-centered {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
